import "../css/About.css";
import { motion } from "framer-motion";
export default function About() {
  return (
    <div className="aboutBody">
      <motion.div
        className="framer"
        initial={{ position: "absolute", top: "0%" }}
        animate={{ position: "absolute", top: "-110%" }}
        exit={{ position: "absolute", top: "0%" }}
        transition={{ duration: 0.5 }}
      >
        <div className="transition"></div>
      </motion.div>

      <div className="mainContent">
        <div className="aboutImg">
          <img
            loading="lazy"
            src={require("../Images/pexels-miguel-á-padriñán-2882509.webp")}
            alt="aboutImg"
          />
        </div>

        <div className="aboutContent">
          <p>
            Hello everyone! My name is Jahid Khan, and I have over 4 years of
            experience in development. 
            <br />
            My coding journey began in November 2021
            when I started learning the fundamentals of web development. Since
            then, I&apos;ve explored various areas, including DevOps, 3D development
            using Three.js, etc. 
            {/* I also have knowledge of Data Structures & Algorithms and DevOps. */}
             {" "}I love making solutions that are efficient, innovative, and easy to use, and
            I&apos;m always excited to learn new technologies and take on
            challenging projects.
            <br />
            {/* <br />
            Talking about my professional experience, I have 1.5 years of working experience as a Frontend and 3D Developer, which I gained through a couple of internships.
            <br /> */}
            <br />
            In between this journey, I launched my YouTube channel called{" "}
            <a
              href="https://www.youtube.com/@techywebdev"
              target="_blank"
              rel="noreferrer"
              style={{ color: "rgb(233, 83, 83)" }}
            >
              Techy Web Dev
            </a>{" "}
            in March, 2022 to share my web development knowledge. Apart from coding, I
            enjoy listening to music and playing games with my friends.
            <br />
            <br />
            Now that you've read about me, if you have any questions, comments,
            or you just want to chat, you can contact me by visiting to the
            Contact Page.
            <br />
            <br />
            <span>- last updated February, 2026</span>
          </p>
        </div>
      </div>
    </div>
  );
}
